import Text from '@cartwhl/ui/base/Text';

export default function ProLabel() {
  return (
    <Text
      className="bg-green/15 flex h-7 items-center justify-center rounded-lg px-2 pt-1 text-center"
      variant="studio/body/xs"
    >
      PRO
    </Text>
  );
}
